export default __webpack_public_path__ + "static/media/logo.a868fe04.png";